import React, { useState, useEffect } from 'react';
import GlobalDialog from './Modal/GlobalDialog';
import { ColumnHeader } from '../models/column-header';
import { Vendor } from '../models/vendor';
import { ColumnEntry } from '../models/column-entry';
import { ColumnSearchRequest } from '../models/column-search-request';
import { ModalMetadata } from '../models/modal-metadata';
import { BenchSheetTechnologyType, ModalMessageType } from '../models/enums';
import { CrudFunctions } from '../utilities/crud-functions';

import DataGrid, {
    Column,
    Selection,
    HeaderFilter,
    FilterRow,
    Scrolling,
    LoadPanel
} from 'devextreme-react/data-grid';

import { TextBox, SelectBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';

export interface Props {
    technology: BenchSheetTechnologyType;
    onUseSelectedEntry?: (columnHeaderId: string, columnEntryId: string) => void;
    onCreateNewEntry?: (columnHeader: ColumnHeader) => void;
    onCancel?: () => void;
}

export default function ColumnLogbookLookup(props: Props) {
    const [columnHeaders, setColumnHeaders] =
        useState<ColumnHeader[]>();

    const [selectedColumnHeader, setSelectedColumnHeader] =
        useState<ColumnHeader>();

    const [columnEntries, setColumnEntries] =
        useState<ColumnEntry[]>();

    const [selectedColumnEntry, setSelectedColumnEntry] =
        useState<ColumnEntry>();

    const [vendors, setVendors] =
        useState<Vendor[]>();

    const [vendorPartNumberFilter, setVendorPartNumberFilter] =
        useState<string>();

    const [columnIdFilter, setColumnIdFilter] =
        useState<string>();

    const [selectedVendorId, setSelectedVendorId] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();
           
    useEffect(() => {
        getAllData();
    }, []);

        return (
            <div>
                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Vendors</div>
                        <SelectBox id="vendors" placeholder='select vendor'
                            className="asset-selectbox"
                            displayExpr="name"
                            valueExpr="vendorId"
                            showClearButton={true}
                            value={selectedVendorId ? selectedVendorId : ''}
                            onValueChanged={vendorChanged}
                            dataSource={vendors} />
                    </div>

                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Vendor Part #</div>
                        <TextBox id="vendorPartNumber" className="textbox"
                            onValueChanged={onVendorPartNumberFilterChanged}
                            placeholder='vendor part number' showClearButton={true}
                            value={vendorPartNumberFilter ? vendorPartNumberFilter : ''} >
                        </TextBox>
                    </div>

                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Column ID</div>
                        <TextBox id="columnId" className="textbox"
                            onValueChanged={onColumnIdFilterChanged}
                            placeholder='column id' showClearButton={true}
                            value={columnIdFilter ? columnIdFilter : ''} />
                    </div>

                    <div>
                        <Button className="pw-row-button-09"
                            text="Search" icon="search"
                            type="success" onClick={searchColumnHeaders} />
                    </div>
                </div>

                <div className="pw-form-unit">
                    <div>
                        <label className="checkbox-row-label">Headers</label>
                        <DataGrid
                            height="18em"
                            dataSource={columnHeaders ? columnHeaders : []}
                            onSelectionChanged={columnHeaderSelectionChanged}
                            rowAlternationEnabled={true}
                            showRowLines={true}
                            showBorders={true}>

                            <LoadPanel enabled={true} />
                            <Selection mode={'single'} />
                            <HeaderFilter visible={true} />
                            <FilterRow visible={true} />
                            <Scrolling showScrollbar='always' mode={'virtual'} />

                            <Column dataField='columnId' caption="ID" width='4rem' />
                            <Column dataField='vendorName' caption="Vendor" width='8rem' />
                            <Column dataField='description' />
                            <Column dataField='dateObtained' dataType="date" width='8rem' />
                            <Column dataField='dateRetired' dataType="date" width='8rem' />
                            <Column dataField='vendorPartNumber' caption="Vendor Part#" width='10rem' />
                            <Column dataField='vendorSerialNumber' caption="Vendor Serial#" width='11rem' />
                            <Column dataField='dimensions' dataType="string" width='18rem' />

                            {/*
                            <Column dataField={'maxTemperature'} dataType="number" width='8rem' />
                            <Column dataField={'uspPhase'} caption="USP Phase" width='8rem' />
                            <Column dataField={'normalPhase'} dataType="boolean" width='10rem' />
                            <Column dataField={'notes'} width="30rem" />
                            */}

                            
                        </DataGrid>
                    </div>

                    <div className="pw-margin-top-05">
                        <label className="checkbox-row-label">Entries</label>
                        <DataGrid
                            height="18em"
                            dataSource={columnEntries ? columnEntries : []}
                            onSelectionChanged={columnEntrySelectionChanged}
                            showBorders={true}>

                            <LoadPanel enabled={true} />
                            <Selection mode={'single'} />
                            <HeaderFilter visible={true} />
                            <FilterRow visible={true} />
                            <Scrolling showScrollbar='always' mode={'virtual'} />

                            <Column dataField={'entryNumber'} dataType="number" caption="Number" />
                            <Column dataField={'runDate'} dataType="date" caption="Date" />
                            <Column dataField={'runPartNumber'} caption="Part#" />
                            <Column dataField={'runLotNumber'} caption="Lot#" />
                        </DataGrid>
                    </div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-centered-buttons-container">
                        {/*
                        <Button id="useSelectedEntry"
                            className="pw-button"
                            text="Use Selected Entry" type="success"
                            hint="use selected entry"
                            height={'2.6em'}
                            onClick={onUseSelectedEntry} />
                            */}

                        <Button id="createNewEntry"
                            className="pw-button"
                            text="Create New Entry" type="success"
                            hint="create new entry"
                            height='2.1rem'
                            onClick={onCreateNewEntry} />

                        <Button id="cancelButton"
                            className="pw-button"
                            text="Cancel" type="normal"
                            hint="cancel"
                            height='2.1rem'
                            onClick={onCancel} />
                    </div>
                </div>

                {globalDialogVisible &&
                    <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
                }

            </div>
        );
    

    function onUseSelectedEntry() {
        if (selectedColumnHeader && selectedColumnHeader.columnHeaderId
            && selectedColumnEntry && selectedColumnEntry.columnEntryId && 
            props.onUseSelectedEntry)
            props.onUseSelectedEntry(
                selectedColumnHeader.columnHeaderId, selectedColumnEntry.columnEntryId);
    }

    function onCreateNewEntry() {
        if (selectedColumnHeader && props.onCreateNewEntry)
            props.onCreateNewEntry(selectedColumnHeader);
    }

    function onCancel() {
        if (props.onCancel)
            props.onCancel();
    }

    function vendorChanged(e: any) {
        setSelectedVendorId(e.value);
    }

    function columnHeaderSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            const header = e.selectedRowsData[0] as ColumnHeader;

            setSelectedColumnHeader(header);
            getColumnEntries(header.columnHeaderId);
        }
    }

    function columnEntrySelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            const entry = e.selectedRowsData[0] as ColumnEntry;

            if (entry)
                setSelectedColumnEntry(entry);
        }        
    }

    function onVendorPartNumberFilterChanged(e: any) {
        setVendorPartNumberFilter(e.value);
        }

    function onColumnIdFilterChanged(e: any) {
        setColumnIdFilter(e.value);
    }

    async function searchColumnHeaders() {
        let request: ColumnSearchRequest = {
            vendorId: selectedVendorId,
            columnId: columnIdFilter,
            vendorPartNumber: vendorPartNumberFilter,
            technologyId: props.technology
        };

        await getColumnHeaders(request)
            .then((data) => {

                console.log(data);

                setColumnHeaders(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Column Headers");
            });
    }

    async function getVendors() {
        await CrudFunctions.getData("common/vendors")
            .then((data) => {
                setVendors(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Venndors");
            });
    }

    async function getColumnHeaders(request: ColumnSearchRequest) {
        return await CrudFunctions.postData("common/columnheaderssearch/vcid", request)
    }

    async function getColumnEntries(columnHeaderId: string) {
        await CrudFunctions.getData(`common/columnentries/${columnHeaderId}`)
            .then((data) => {
                setColumnEntries(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Column Entries");
            });
    }

    async function getAllData() {
        await getVendors();        
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}

